module.exports = __webpack_public_path__ + "img/orange-chev.b7ba42e6.svg";